import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/event/`;

class cdoEvent {
    record = (data, callback) => {
        util.putJSON(servicesURL + 'record', data, callback);
    }

    recordDialog = (data, callback) => {
        util.putJSON(servicesURL + 'record-dialog', data, callback);
    }

    recordNameRevelations = (data, callback) => {
        util.putJSON(servicesURL + 'record-name-revelations', data, callback);
    }

    recordTransaction = (data, callback) => {
        util.putJSON(servicesURL + 'record-transaction', data, callback);
    }

    recordCombat = (data, callback) => {
        util.putJSON(servicesURL + 'record-combat', data, callback);
    }

    selectMemoryForBeing = (data, callback) => {
        util.putJSON(servicesURL + 'select-memory-for-being', data, callback);
    }

    selectByPlace = (data, callback) => {
        util.putJSON(servicesURL + 'select-by-place', data, callback);
    }

    selectMetBetweenEntities = (data, callback) => {
        util.putJSON(servicesURL + 'select-met-between-entities', data, callback);
    }

    entityKnowsName = (data, callback) => {
        util.putJSON(servicesURL + 'entity-knows-name', data, callback);
    }

    pcKnowsBeingName = (data, callback) => {
        util.putJSON(servicesURL + 'pc-knows-being-name', data, callback);
    }

    beingKnowsPcName = (data, callback) => {
        util.putJSON(servicesURL + 'being-knows-pc-name', data, callback);
    }

    deleteAll = (callback) => {
        util.putJSON(servicesURL + 'delete-all', {}, callback);
    }
}

const cdo = new cdoEvent();
export default cdo;
